<div *ngIf="productUpdateNoteFound" class="alert-color row"><i class="fas fa-exclamation-triangle alert-color"></i>&nbsp;No NDC Product Updates/Revision notices found for date range</div>

<div class="ndc-product-update-notifications-page" *ngIf="!productUpdateNoteFound">
  <div *ngIf="!showItemsWithoutReversingOrder">
    <div *ngFor="let recipient of tableData | keyvalue : reverseOrder">
      <h3 class="mt-3">{{ getMonthAndYearInTexts(recipient.key) }}</h3>

      <div class="row tbrow">
        <div class="col-sm-2">Live Date</div>

        <div class="col-sm-2">Status</div>

        <div class="col-sm-3">Summary</div>

        <div class="col-sm-2">Environment</div>

        <div class="col-sm-2">API(s) Impacted</div>

        <div class="col-sm-1">Notification</div>
      </div>

      <div *ngFor="let monthItem of recipient.value">
        <a *ngFor="let monthItemInfo of monthItem?.revisionNotices" [href]="monthItemInfo?.url" class="td-link ms-15">
          <h5 id="title">
            <span>
              <i class="fa fa-info-circle blu"></i>
              {{ monthItemInfo.title }}
            </span>
          </h5>

          <div class="row itmrow">
            <div class="col-sm-2" [innerHtml]="monthItemInfo?.liveDate || '' | dateFormat"></div>

            <div class="col-sm-2" [innerHtml]="monthItemInfo?.status || '' | mdToHtml"></div>

            <div class="col-sm-3" [innerHtml]="monthItemInfo?.summary || '' | mdToHtml"></div>

            <div class="col-sm-2" [innerHtml]="monthItemInfo?.environment || '' | mdToHtml"></div>

            <div class="col-sm-2" [innerHtml]="monthItemInfo?.apiImpacted || '' | mdToHtml"></div>

            <div class="col-sm-1" [innerHtml]="monthItemInfo?.notification || '' | mdToHtml"></div>
          </div>
        </a>
      </div>
    </div>
  </div>

  <div *ngIf="showItemsWithoutReversingOrder">
    <div *ngFor="let recipient of tableData | keyvalue : reverseOrder">
      <h3 class="mt-3">{{ getMonthAndYearInTexts(recipient.key) }}</h3>

      <div class="row tbrow">
        <div class="col-sm-2">Live Date</div>

        <div class="col-sm-2">Status</div>

        <div class="col-sm-3">Summary</div>

        <div class="col-sm-2">Environment</div>

        <div class="col-sm-2">API(s) Impacted</div>

        <div class="col-sm-1">Notification</div>
      </div>

      <div *ngFor="let monthItem of recipient.value">
        <a *ngFor="let monthItemInfo of monthItem?.revisionNotices" [href]="monthItemInfo?.url" class="td-link ms-15">
          <h5 id="title">
            <span>
              <i class="fa fa-info-circle blu"></i>
              {{ monthItemInfo.title }}
            </span>
          </h5>

          <div class="row itmrow">
            <div class="col-sm-2" [innerHtml]="monthItemInfo?.liveDate || '' | dateFormat"></div>

            <div class="col-sm-2" [innerHtml]="monthItemInfo?.status || '' | mdToHtml"></div>

            <div class="col-sm-3" [innerHtml]="monthItemInfo?.summary || '' | mdToHtml"></div>

            <div class="col-sm-2" [innerHtml]="monthItemInfo?.environment || '' | mdToHtml"></div>

            <div class="col-sm-2" [innerHtml]="monthItemInfo?.apiImpacted || '' | mdToHtml"></div>

            <div class="col-sm-1" [innerHtml]="monthItemInfo?.notification || '' | mdToHtml"></div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
